import { IOfficialLicenseGradeManage } from "../_common/interface/officialLicenseGrade/iOfficialLicenseGradeManage";
import { API_URL } from "../_config/config.const";
import { getBody } from "../_helpers/body.helper";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";
import { normalizeOfficialLicenseGradeListPayload, normalizeOfficialLicenseGradeRow } from "../_helpers/officialLicenseGradeDeserialize.helper";
import { getQuery } from "../_helpers/query.helper";

const API_NAME = "officialLicenseGrade";

export const officialLicenseGradeService = {
    getAll,
    get,
    post,
    disable,
    dropdown,
    submit(model?: any) {
        const id = Number(model?.id);
        return id > 0 ? put(model) : post(model);
    }
};

function getAll(query: any) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetAll?${getQuery(query)}`, requestOptions)
        .then(handleResponse)
        .then((payload: any) => normalizeOfficialLicenseGradeListPayload(payload));
}

function get(id: number) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/Get/?id=${id}`, requestOptions)
        .then(handleResponse)
        .then((row: any) => normalizeOfficialLicenseGradeRow(row));
}
function post(model: IOfficialLicenseGradeManage) {
    const requestOptions = { method: 'POST', headers: getHeader(), body: getBody(model) };
    return fetch(`${API_URL}/${API_NAME}/`, requestOptions).then(handleResponse);
}

function put(model?: IOfficialLicenseGradeManage) {
    const requestOptions = { method: 'PUT', headers: getHeader(), body: getBody(model) };
    return fetch(`${API_URL}/${API_NAME}`, requestOptions).then(handleResponse);
}

function disable(id: number) {
    const requestOptions = { method: 'DELETE', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/${id}`, requestOptions).then(handleResponse);
}

function dropdown(parentId?: number | string) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/dropdown/?officialLicenseTypeId=${parentId || ""}`, requestOptions).then(handleResponse);
}
